import styled, { css } from 'styled-components'
import { ReactComponent as MaskIcon } from '@sketch/icons/arrow-left-down-17'

export const ElementIconContainer = styled.div<{ $isSymbol?: boolean }>(
  ({ theme, $isSymbol }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    color: ${$isSymbol ? theme.colors.inspect.component.A : 'inherit'};

    [aria-selected='true'] & {
      /* When a symbol is selected we don't change the icon color */
      color: inherit;
    }
  `
)

export const StyledMaskedIcon = styled(MaskIcon)`
  width: 17px;
  height: 17px;
  margin-top: 1px; /* stylelint-disable-line scales/space */
`
